import React from "react";

interface SalaryTableProps {
  allUsersPayroll: any[];
}

const columns = [
  {
    label: "Employee",
    accessor: (userPayroll: any) => userPayroll.username,
    minWidth: "min-w-[120px]",
  },
  {
    label: "Basic Salary",
    accessor: (userPayroll: any) => userPayroll.data?.earnings?.basicSalary ?? 0,
  },
  {
    label: "DA",
    accessor: (userPayroll: any) => userPayroll.data?.earnings?.dearnessAllowance ?? 0,
  },
  {
    label: "HRA",
    accessor: (userPayroll: any) => userPayroll.data?.earnings?.houseRentAllowance ?? 0,
  },
  {
    label: "LTA",
    accessor: (userPayroll: any) => userPayroll.data?.earnings?.leaveTravelAllowance ?? 0,
  },
  {
    label: "Special Allowance",
    accessor: (userPayroll: any) => userPayroll.data?.earnings?.specialAllowance ?? 0,
  },
  {
    label: "Employee PF",
    accessor: (userPayroll: any) => userPayroll.data?.deductions?.employeeProvidentFund ?? 0,
  },
  {
    label: "Employee ESIC",
    accessor: (userPayroll: any) => userPayroll.data?.deductions?.employeeEsicContribution ?? 0,
  },
  {
    label: "Professional Tax",
    accessor: (userPayroll: any) => userPayroll.data?.deductions?.professionalTax ?? 0,
  },
  {
    label: "Employer PF",
    accessor: (userPayroll: any) => userPayroll.data?.employerContributions?.employerProvidentFund ?? 0,
  },
  {
    label: "Employer ESIC",
    accessor: (userPayroll: any) => userPayroll.data?.employerContributions?.employerEsicContribution ?? 0,
  },
  {
    label: "Gratuity",
    accessor: (userPayroll: any) => userPayroll.data?.employerContributions?.gratuity ?? 0,
  },
  {
    label: "Gross Salary",
    accessor: (userPayroll: any) => (
      (userPayroll.data?.earnings?.basicSalary ?? 0) +
      (userPayroll.data?.earnings?.dearnessAllowance ?? 0) +
      (userPayroll.data?.earnings?.houseRentAllowance ?? 0) +
      (userPayroll.data?.earnings?.leaveTravelAllowance ?? 0) +
      (userPayroll.data?.earnings?.specialAllowance ?? 0)
    ),
  },
  {
    label: "Total Deductions",
    accessor: (userPayroll: any) => userPayroll.data?.totalDeductions ?? 0,
  },
  {
    label: "Net Salary",
    accessor: (userPayroll: any) => userPayroll.data?.netSalary ?? 0,
  },
  {
    label: "Total Company Benefits",
    accessor: (userPayroll: any) => userPayroll.data?.totalEmployerCost ?? 0,
  },
  {
    label: "CTC (Monthly)",
    accessor: (userPayroll: any) => userPayroll.data?.costToCompany ?? 0,
  },
];

const SalaryTable: React.FC<SalaryTableProps> = ({ allUsersPayroll }) => {
  if (!allUsersPayroll || allUsersPayroll.length === 0) return null;

  return (
    <div className="mt-8">
      <div className="overflow-x-auto">
        <table className="w-full text-sm border">
          <thead>
            <tr className="bg-gray-50">
              {columns.map((column, index) => (
                <th
                  key={index}
                  className={`border px-3 py-2 ${index === 0 ? "text-left" : "text-right"} ${column.minWidth || "min-w-[100px]"}`}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allUsersPayroll.map((userPayroll) => (
              <tr key={userPayroll.userId}>
                {userPayroll.error ? (
                  <td
                    colSpan={columns.length}
                    className="border px-3 py-2 text-center text-red-500"
                  >
                    {userPayroll.error}
                  </td>
                ) : (
                  columns.map((column, index) => (
                    <td
                      key={index}
                      className={`border px-3 py-2 ${index === 0 ? "text-left" : "text-right"}`}
                    >
                      {column.accessor(userPayroll).toLocaleString()}
                    </td>
                  ))
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SalaryTable;